import { combineEpics } from "redux-observable";
import Scores2020Epic from "./2020-scores-fetch";

export default combineEpics(Scores2020Epic);
